// BANEO — cart page: "Ajoute à ta commande" adds the product with AJAX and refreshes
// Dawn's cart sections (items, summary, cart icon) without reloading the page.
(function () {
  function sectionsToRender() {
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    return [
      items && { id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' },
      footer && { id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ].filter(Boolean);
  }

  function render(sections, html) {
    sections.forEach(({ id, section, selector }) => {
      const markup = html[section];
      const container = document.getElementById(id);
      if (!markup || !container) return;
      const source = new DOMParser().parseFromString(markup, 'text/html').querySelector(selector);
      const target = container.querySelector(selector) || container;
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function init() {
    document.querySelectorAll('[data-baneo-upsell]').forEach((upsell) => {
      const button = upsell.querySelector('[data-variant-id]');
      const errorBox = upsell.querySelector('.baneo-upsell__error');
      if (!button || button.dataset.bound) return;
      button.dataset.bound = 'true';

      button.addEventListener('click', () => {
        const sections = sectionsToRender();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
            sections: sections.map((s) => s.section),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) throw new Error(response.description || response.message);
            render(sections, response.sections || {});
            upsell.remove(); // already in the cart now
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: response });
            }
          })
          .catch((error) => {
            button.disabled = false;
            if (errorBox) {
              errorBox.textContent = error.message || window.cartStrings?.error || 'Une erreur est survenue. Réessaie.';
              errorBox.hidden = false;
            }
          })
          .finally(() => button.removeAttribute('aria-busy'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
